import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

export const NoHiddenFeesSection = () => {
  const { t } = useTranslation();

  return (
    <section
      id="pricing"
      className={`
        bg-[#F1F1F3] rounded-[24px] bg-no-hidden-fees bg-no-repeat bg-cover 
        mx-auto px-4 py-10 sm:py-0 sm:px-0
        w-full max-w-[1204px]
        overflow-hidden
        lg:h-[432px]
        lg:w-[1204px] scroll-mt-[200px] sm:scroll-mt-[330px] lg:scroll-mt-[120px]
      `}
    >
      <div className="relative w-full">
        <div className=" px-12 pt-12 max-w-[600px]">
          <p className="text-[#005FCC] text-[12px] sm:text-[14px] leading-[17px] font-bold uppercase">
            {t('noFees.title')}
          </p>
          <h2 className="font-archivo font-extrabold text-[28px] sm:text-[40px] leading-[36px] sm:leading-[48px] text-[#1D3D59]">
            {t('noFees.subTitlePre')} <br className="hidden sm:block" />
            {t('noFees.subTitlePost')}
          </h2>
          <Button
            type="primary"
            href="#contact"
            size="large"
            className="mt-6 sm:mt-8 rounded-lg px-8 font-semibold font-archivo"
            style={{ backgroundColor: '#005FCC', borderColor: '#005FCC' }}
          >
            {t('common.contact')}
          </Button>
        </div>

        <div className="flex flex-col gap-4 sm:block mt-8 sm:mt-0 sm:p-4">
          <div
            className="flex flex-col items-start p-4 bg-white rounded-[24px]
            w-full lg:absolute
            lg:w-[389px]
            lg:h-[104px]
            sm:mt-4
            "
            style={{
              boxShadow: '0px 4px 31.3px rgba(0, 0, 0, 0.06)',
              left: 600,
              top: 31,
            }}
          >
            <h3 className="font-archivo font-semibold text-[20px] leading-[32px] text-[#1D3D59] mb-1">
              💰{t('noFees.message1.title')}
            </h3>
            <p className="font-archivo font-normal text-[14px] leading-[20px] text-[#707070]">
              {t('noFees.message1.subTitle')}
            </p>
          </div>

          <div
            className="flex flex-col items-start p-4 bg-white rounded-[24px]
            w-full lg:absolute
            lg:w-[389px]
            lg:h-[104px]
            sm:mt-4"
            style={{
              boxShadow: '0px 4px 31.3px rgba(0, 0, 0, 0.06)',
              left: 780,
              top: 150,
            }}
          >
            <h3 className="font-archivo font-semibold text-[20px] leading-[32px] text-[#1D3D59] mb-1">
              🔗 {t('noFees.message2.title')}
            </h3>
            <p className="font-archivo font-normal text-[14px] leading-[20px] text-[#707070]">
              {t('noFees.message2.subTitle')}
            </p>
          </div>

          <div
            className="flex flex-col items-start p-4 bg-white rounded-[24px]
            w-full lg:absolute
            lg:w-[389px]
            lg:h-[112px]
            sm:mt-4"
            style={{
              boxShadow: '0px 4px 31.3px rgba(0, 0, 0, 0.06)',
              left: 530,
              top: 295,
            }}
          >
            <h3 className="font-archivo font-semibold text-[20px] leading-[32px] text-[#1D3D59] mb-1">
              ⏳ {t('noFees.message3.title')}
            </h3>
            <p className="font-archivo font-normal text-[14px] leading-[20px] text-[#707070]">
              {t('noFees.message3.subTitle')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
